import { isPremiumFunc, isProfessionalFunc } from '../helper';
import { memberRoles, plansName } from '../constants';

export const routesList = [
  '/app/homework',
  '/app/homework-list',
  '/app/act-coach',
  '/app/dbt-coach',
  '/app/mi-coach',
  '/app/cbt-companion',
  '/app/dbt-daily',
  '/app/emdr',
  '/app/subscription',
  '/app/groups',
  '/app/assessments',
  '/app/assessments/config',
  '/app/coverage',
  '/app/appointment',
  '/app/communication',
  '/app/clients',
  '/app/billings',
  '/app/account-activity',
  '/app/insights',
  '/app/settings/practice-details',
  '/app/settings/billing-and-service',
  '/app/settings/documents',
  '/app/settings/notifications',
  '/app/settings/notesAndForms',
  '/app/settings/client-portal',
  '/app/settings/insurance-payer',
  '/app/team_members',
  '/app/assessments/population',
  '/app/profile',
  'Billing',
  'Insights',
  'Activity',
  'Reminders',
  'Supervision',
  /** Sub menus and all other */
  'Basic Info',
  'Practice',
  'PracticeDetails',
  'BillingAndServices',
  'NotesAndForms',
  /** */
  'Documents',
  'Notifications',
  'InsurancePayers',
  'BookingWidget',
  'ClientReminders',
  'ClientPortal',
  'SecureMessaging',
  // "DataExport",
  'TeamMembers',
  'BusinessDocuments',
  'DemoData',
  'Administration',
  'PracticeManagement',
];

export const routePermission = {
  '/app/homework': 'Homework',
  '/app/homework-list': 'Homework',
  '/app/act-coach': 'Apps',
  '/app/dbt-coach': 'Apps',
  '/app/mi-coach': 'Apps',
  '/app/cbt-companion': 'Apps',
  '/app/dbt-daily': 'Apps',
  '/app/emdr': 'Apps',
  '/app/subscription': 'Subscription',
  '/app/groups': 'Groups',
  '/app/assessments': 'Assessments',
  '/app/assessments/config': 'Assessments',
  '/app/assessments/population': 'Assessments',
  '/app/coverage': 'Coverage',
  '/app/appointment': 'Appointment',
  '/app/appointment-status': 'Appointment',
  '/app/communication': 'SecureMessaging',
  '/app/clients': 'Clients',
  '/app/billings': 'Billing',
  '/app/billings/insurance_payments/new': 'Billing.AddPayment',
  '/app/account-activity': 'Activity',
  '/app/insights': 'Insights',
  '/app/settings/practice-details': 'PracticeDetails',
  // "/app/settings/billing-and-service":"BillingAndServices",
  '/app/settings/documents': 'Documents',
  '/app/settings/notifications': 'Notifications',
  '/app/settings/notesAndForms': 'NotesAndForms',
  '/app/settings/client-portal': 'ClientPortal',
  '/app/settings/insurance-payer': 'InsurancePayers',
  '/app/team_members': 'TeamMembers',
  '/app/profile': 'Profile',
};

const Permissions = {
  [memberRoles.owner]: [
    'UpgradePlan',
    'Profile',
    /** Main sidebar */
    'Homework',
    'Apps',
    'Subscription',
    'Groups',
    'Dashboard',
    'Assessments',
    'Coverage',
    /** *****************Appointment******** */
    'Appointment',
    'Appointment.all',
    'Appointment.create',
    /** *****************Appointment******** */

    /** *****************Clients******** */
    'Clients',
    'Clients.create',
    'Clients.edit',
    'Clients.notes',
    /** *****************Clients******** */

    /** *****************Client Billings******** */
    'ClientsBilling',
    'ClientsBilling.all',
    /** *****************Client Billings******** */

    /** *****************Client Summary******** */
    'ClientsSummary.all',
    /** *****************Client Summary******** */

    /** ************* Billing *********** */
    'Billing',
    'Billing.RecentTransaction',
    'Billing.Documents',
    'Billing.UnBilled',
    'Billing.Claims',
    'Billing.Payment',
    'Billing.AddPayment',
    'Billing.Insurance',
    /** ************* Billing *********** */

    'Insights',
    /** ****************************** */
    // Billing and Insurance section
    'Transactions',
    'Insurance Payments',
    'Insurance',
    'Setup CreditCard',
    /** ******************************* */
    'Activity',
    'Reminders',
    'Supervision',
    /** Sub menus and all other */
    'Basic Info',
    'Practice',
    'PracticeDetails',
    'BillingAndServices',
    'NotesAndForms',
    /** */
    'Documents',
    'Notifications',
    'InsurancePayers',
    'BookingWidget',
    'ClientReminders',
    'ClientPortal',
    'SecureMessaging',
    // "DataExport",
    'TeamMembers',
    'BusinessDocuments',
    'DemoData',
  ],
  [memberRoles.clinicianAdmin]: [
    'UpgradePlan',
    'Profile',
    /** Main sidebar */
    'Homework',
    'Apps',
    'Subscription',
    'Groups',
    'Dashboard',
    'Assessments',
    'Coverage',

    /** *****************Appointment******** */
    'Appointment',
    'Appointment.all',
    'Appointment.create',
    /** *****************Appointment******** */

    /** *****************Clients************ */
    'Clients',
    'Clients.create',
    'Clients.edit',
    'Clients.notes',
    /** *****************Clients************ */

    /** *****************Client Billings******** */
    'ClientsBilling',
    'ClientsBilling.all',
    /** *****************Client Billings******** */

    /** *****************Client Summary******** */
    'ClientsSummary',
    'ClientsSummary.all',
    /** *****************Client Summary******** */

    /** ************* Billing *********** */
    'Billing',
    'Billing.RecentTransaction',
    'Billing.Documents',
    'Billing.UnBilled',
    'Billing.Claims',
    'Billing.Payment',
    'Billing.AddPayment',
    'Billing.Insurance',
    /** ************* Billing *********** */

    'Insights',
    'Activity',
    'Reminders',
    'Supervision',
    /** Sub menus and all other */
    'Basic Info',
    /** ****************************** */
    // Billing and Insurance section
    'Transactions',
    'Insurance Payments',
    'Insurance',
    'Setup CreditCard',
    /** ******************************* */
    'Practice',
    'PracticeDetails',
    'BillingAndServices',
    'NotesAndForms',
    /** */
    'Documents',
    'Notifications',
    'InsurancePayers',
    'BookingWidget',
    'ClientReminders',
    'ClientPortal',
    'SecureMessaging',
    'DataExport',
    'TeamMembers',
    'BusinessDocuments',
    'DemoData',
  ],
  [memberRoles.clinicianFullClient]: [
    'Profile',
    /** Main sidebar */
    'Homework',
    'Apps',
    'Groups',
    'Dashboard',
    'Assessments',
    /** *****************Appointment******** */
    'Appointment',
    'Appointment.all',
    'Appointment.create',
    /** *****************Appointment******** */

    /** *****************Client Billings******** */
    'ClientsBilling.own',
    /** *****************Client Billings******** */

    /** *****************Client Summary******** */
    'ClientsSummary.other',
    'ClientsSummary.own',
    /** *****************Client Summary******** */

    /** *****************Clients******** */
    'Clients',
    'Clients.create',
    'Clients.edit',
    'Clients.ownNotes',
    /** *****************Clients******** */

    /** ************* Billing ************
		"Billing",
		"Billing.RecentTransaction.own",
		"Billing.Documents.own",
		"Billing.UnBilled.own",
		"Billing.Claims.own",
		"Billing.Insurance",
		 Billing *********** */
    // "Insights",
    'Reminders',
    // "PracticeDetails",
    /** Sub menus and all other */
    'BasicInfo',
    'Notifications',
    'ScheduleAppointment',
  ],
  [memberRoles.clinicianBasicBilling]: [
    'Profile',
    /** Main sidebar */
    'Homework',
    'Apps',
    'Groups',
    'Dashboard',
    'Assessments',
    /** *****************Appointment******** */
    'Appointment',
    'Appointment.create',
    'Appointment.own',
    /** *****************Appointment******** */

    /** *****************Clients******** */
    'Clients',
    'Clients.create',
    'Clients.edit',
    'Clients.ownNotes',
    /** *****************Clients******** */

    /** *****************Client Billings******** */
    'ClientsBilling.own',
    /** *****************Client Billings******** */

    /** *****************Client Summary******** */
    'ClientsSummary.own',
    /** *****************Client Summary******** */

    /** ************* Billing *********** */
    'Billing',
    'Billing.RecentTransaction.own',
    'Billing.UnBilled.own',
    'Billing.Claims.own',
    'Billing.Insurance',
    /** ************* Billing *********** */
    // "Insights",
    'Reminders',
    // "PracticeDetails",
    /** Sub menus and all other */
    'BasicInfo',
    'Notifications',
    /** */
    'ScheduleAppointment',
  ],
  [memberRoles.clinicianBasic]: [
    'Profile',
    /** Main sidebar */
    'Homework',
    'Apps',
    'Subscription',
    'Groups',
    'Dashboard',
    'Assessments',
    /** *****************Appointment******** */
    'Appointment',
    'Appointment.create',
    'Appointment.own',
    /** *****************Appointment******** */

    /** *****************Clients******** */
    'Clients',
    'Clients.create',
    'Clients.edit',
    'Clients.ownNotes',
    /** *****************Clients******** */

    /** *****************Client Summary******** */
    'ClientsSummary.other',
    /** *****************Client Summary******** */

    // "Insights",
    'Reminders',
    // "PracticeDetails",

    /** Sub menus and all other */
    'BasicInfo',
    'Notifications',
    'ScheduleAppointment',
  ],
  [memberRoles.supervisor]: [
    'Profile',
    /** *****************Appointment******** */
    'Appointment',
    'Appointment.locked',
    /** *****************Appointment******** */
    'Reminders',
    'Supervision',
    // "PracticeDetails",
    'BasicInfo',
    'Notifications',
  ],
  [memberRoles.biller]: [
    'Profile',
    /** *****************Appointment******** */
    'Appointment',
    'Appointment.locked',
    /** *****************Appointment******** */

    /** *****************Clients******** */
    'Clients',
    'Clients.edit',
    /** *****************Clients******** */

    /** *****************Client Billings******** */
    'ClientsBilling',
    'ClientsBilling.all',
    /** *****************Client Billings******** */

    /** *****************Client Summary******** */
    'ClientsSummary.all',
    /** *****************Client Summary******** */

    /** ************* Billing *********** */
    'Billing',
    'Billing.RecentTransaction',
    'Billing.Documents',
    'Billing.UnBilled',
    'Billing.Claims',
    'Billing.Payment',
    'Billing.AddPayment',
    'Billing.Insurance',
    /** ************* Billing *********** */

    'Reminders',
    // "Insights",
    'BillingAndServices',
    'BasicInfo',
    // "PracticeDetails",
    'Notifications',
    'InsurancePayers',
  ],
  [memberRoles.scheduler]: [
    'Profile',
    /** *****************Appointment******** */
    'Appointment',
    'Appointment.create',
    'Appointment.own',
    /** *****************Appointment******** */

    /** *****************Clients******** */
    'Clients',
    'Clients.create',
    'Clients.edit',
    /** *****************Clients******** */

    /** *****************Client Billings******** */
    'ClientsBilling',
    'ClientsBilling.notClaim',
    /** *****************Client Billings******** */

    /** *****************Client Summary******** */
    'ClientsSummary.all',
    /** *****************Client Summary******** */

    'Reminders',
    // "Insights",
    // "PracticeDetails",
    'BasicInfo',
    'Notifications',
    // "InsurancePayers"
  ],
};

const PermissionsForPlans = {
  [plansName.professional]: [
    '/app/profile',
    /** Main sidebar */
    '/app/homework',
    '/app/homework-list',
    '/app/act-coach',
    '/app/dbt-coach',
    '/app/mi-coach',
    '/app/emdr',
    '/app/cbt-companion',
    '/app/dbt-daily',
    '/app/subscription',
    '/app/groups',
    '/app/assessments',
    '/app/assessments/config',
    '/app/assessments/population',
    '/app/coverage',
    '/app/appointment',
    '/app/communication',
    '/app/clients',
    '/app/billings',
    '/app/account-activity',
    '/app/insights',
    '/app/settings/practice-details',
    '/app/settings/billing-and-service',
    '/app/settings/documents',
    '/app/settings/notifications',
    '/app/settings/notesAndForms',
    '/app/settings/client-portal',
    '/app/settings/insurance-payer',
    '/app/team_members',
    'ExportApps',
    'Billing',
    'Insights',
    'Activity',
    'Reminders',
    'Supervision',
    /** Sub menus and all other */
    'Basic Info',
    'Practice',
    'PracticeDetails',
    'BillingAndServices',
    'NotesAndForms',
    /** */
    'Documents',
    'Notifications',
    'InsurancePayers',
    'BookingWidget',
    'ClientReminders',
    'ClientPortal',
    'SecureMessaging',
    // "DataExport",
    'TeamMembers',
    'BusinessDocuments',
    'DemoData',
    'Administration',
    'PracticeManagement',
  ],
  [plansName.premium]: [
    '/app/profile',
    /** Main sidebar */
    '/app/homework',
    '/app/homework-list',
    '/app/act-coach',
    '/app/dbt-coach',
    '/app/mi-coach',
    '/app/emdr',
    '/app/cbt-companion',
    '/app/dbt-daily',
    '/app/subscription',
    '/app/appointment',
    '/app/communication',
    '/app/groups',
    '/app/assessments',
    '/app/assessments/config',
    '/app/assessments/population',
    '/app/clients',
    '/app/team_members',
    'ExportApps',
    /*	"/app/billings",
      "/app/account-activity",
      "/app/insights",
      "/app/settings/practice-details",
      "/app/settings/billing-and-service",
      "/app/settings/documents",
      "/app/settings/notifications",
      "/app/settings/notesAndForms",
      "/app/settings/client-portal",
      "/app/settings/insurance-payer",
      "Apps",
      "Subscription",
      "Groups",
      "Insights",
      "Dashboard",
      "Assessments",
      "Activity",
      "PracticeDetails",
      /!** Sub menus and all other *!/
          /!** *!/
      "PracticeSetting",
      "TeamMembers",
      "Administration", */
    'SecureMessaging',
  ],
  [plansName.basic]: [
    '/app/profile',
    /** Main sidebar */
    '/app/act-coach',
    '/app/dbt-coach',
    '/app/mi-coach',
    '/app/emdr',
    '/app/cbt-companion',
    '/app/dbt-daily',
    '/app/insights',
    '/app/clients',
    '/app/team_members',
    'Apps',
    '/app/account-activity',
    'Insights',
    'Dashboard',
    'Activity',
    /** Sub menus and all other */
    /** */
  ],
};

export const hasAccessOf = functionality => {
  let UserRoles = localStorage.getItem('custom:teamRoles');
  UserRoles = UserRoles ? JSON.parse(UserRoles) : [];
  let hasAccess = false;
  UserRoles.forEach(u => {
    if (Permissions[u].includes(functionality)) {
      hasAccess = true;
      return true;
    }
  });
  return hasAccess;
};

export const hasAccessOfPlans = functionality => {
  let UserRoles = localStorage.getItem('currentPlan');
  const enterprisePlan = localStorage.getItem('enterprisePlan') === 'true';
  const isPremiumOverride = isPremiumFunc();
  const isProfessionalOverride = isProfessionalFunc();
  UserRoles = UserRoles ? JSON.parse(UserRoles) : {};
  let hasAccess = false;
  let name = UserRoles?.planName || UserRoles?.name;
  name = isProfessionalOverride
    ? plansName.professional
    : name === plansName.basic && (isPremiumOverride || enterprisePlan)
    ? plansName.premium
    : name;

  if (name && PermissionsForPlans[name].includes(functionality)) {
    hasAccess = true;
    return true;
  }
  return hasAccess;
};
